import React, {useContext, useEffect} from "react";
import {ModalDispatch} from "../context/ModalContext";
import {ConfigDispatch} from "../context/ConfigContext";
import {AuthContext} from "../context/LoginContext";
import WCLoginService from "../services/WCLoginService";
import PasswordChangeForm from "./PasswordChangeForm";
import LoginFormWrapper from "./LoginFormWrapper";
import {TextSectionsList} from "./TextSectionsList";
import SavedConfigurationList from "./SavedConfigurationList";
import {SavedConfigurationsDispatch} from "../context/SavedConfigurationsContext";
import ConfigurationsService from "../services/ConfigurationsService";
import {LoaderContext} from "../context/LoaderContext";
import logo from './../images/LOGO KOLOR_BIAŁE TŁO.jpg';
import logo2 from './../images/LOGO BIAŁE_CZARNE TŁO.jpg';
import logoEU from './../images/eu.jpg';
import InitConfig from "./InitConfig";
import {useLanguage} from "../context/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

const DOTACJE_URL = 'https://akcesorianagrobkowe.pl/dotacje/';

export const AppMainContainer = () => {
    //config
    const configDataDispatch = useContext(ConfigDispatch);
    const {t} = useLanguage();
    //loader
    const loaderContext = useContext(LoaderContext);
    //get token and email from url
    const urlParams = new URLSearchParams(window.location.search);
    const tokenParam = urlParams.get('token');
    const emailParam = urlParams.get('email');
    const contrastParam = urlParams.get('contrast');
    const [email, setEmail] = React.useState(emailParam);
    const [token, setToken] = React.useState(tokenParam);
    //modal
    const modalDispatch = useContext(ModalDispatch);
    //tabs
    const [loginTab, setLoginTab] = React.useState(false);
    const [configuratorTab, setConfiguratorTab] = React.useState(true);
    const [exportTab, setExportTab] = React.useState(false);
    //saved configurations
    const savedConfigurationsDispatch = useContext(SavedConfigurationsDispatch);
    //user data
    const user = useContext(AuthContext);
    // Rozmiar czcionki (domyślnie 62.5% na <html>)
    const [fontSize, setFontSize] = React.useState(62.5);
    // Stan dla wysokiego kontrastu
    const [highContrast, setHighContrast] = React.useState(contrastParam === '1');

    // Zmiana rozmiaru czcionki na całej stronie (na <html>)
    useEffect(() => {
        document.documentElement.style.fontSize = `${fontSize}%`;
    }, [fontSize]);

    // Przełączanie kontrastu
    const toggleContrast = (e) => {
        if (e) e.preventDefault();
        setHighContrast(prev => !prev);
    };

    // Efekt dla zmiany kontrastu
    useEffect(() => {
        document.documentElement.classList.toggle('high-contrast', highContrast);
    }, [highContrast]);

    // Obsługa powiększania/pomniejszania tekstu
    const increaseFontSize = (e) => {
        if (e) e.preventDefault();
        setFontSize(prev => Math.min(prev + 10, 200)); // max 200%
    };
    const decreaseFontSize = (e) => {
        if (e) e.preventDefault();
        setFontSize(prev => Math.max(prev - 10, 40)); // min 40%
    };

    useEffect(() => {
        if (user.isLoggedIn) updateConfigurationList();
        if (email && token) checkCredentialsForResettingPassword(email, token);
    });

    //update saved configurations list
    const updateConfigurationList = async () => {
        const service = new ConfigurationsService();
        //get configurations list
        const saveConfigurationResponse = await service.getConfigurations();
        //console.log('saveConfigurationResponse', saveConfigurationResponse);
        //update configurations list
        savedConfigurationsDispatch({
            type: 'set',
            payload: saveConfigurationResponse
        });
    }
    //handle tabs switch
    const closeAllTabs = () => {
        setLoginTab(false);
        setConfiguratorTab(false);
        setExportTab(false);
    }
    const handleLoginTab = (e) => {
        e.preventDefault();
        closeAllTabs();
        setLoginTab(true);
    }
    const handleConfiguratorTab = (e) => {
        e.preventDefault();
        closeAllTabs();
        setConfiguratorTab(true);
    }

    async function checkCredentialsForResettingPassword(email, token) {
        const response = await WCLoginService.checkCredentialsForResettingPassword(email, token);
        if (response.status === 'success') {
            modalDispatch({
                type: 'showModal'
            });
            modalDispatch({
                type: 'setModalContent',
                payload: {
                    title: t('auth.confirmNewPassword'),
                    content:
                        <PasswordChangeForm
                            email={email}
                        />
                }
            });
        } else {
            modalDispatch({
                type: 'showModal'
            });
            modalDispatch({
                type: 'setModalContent',
                payload: {
                    title: t('common.error'),
                    content: '',
                }
            });
            modalDispatch({type: 'setErrorMsg', payload: response.message});
        }
        setEmail(null);
        setToken(null);
    }

    return (
        <div className={`App${highContrast ? ' App--high-contrast' : ''}`} role="main">
            <InitConfig/>
            <div className={`loader ${loaderContext.active ? 'active' : ''}`} aria-live="polite"
                 aria-busy={loaderContext.active}>
                <div className="loader__inner">
                    <div className="spinner-border" role="status" aria-label={t('common.loading')}>
                        <span className="sr-only"></span>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <nav className="navigation__wrapper" aria-label={t('nav.mainNavigation')}>
                        <ul className="navigation" role="menubar" aria-label={t('nav.mainMenu')}>
                            <li className="navigation__item navigation__item--logo" role="none">
                                <a className={`navigation__link navigation__link--logo`} href="https://akcesorianagrobkowe.pl/" tabIndex="0"
                                   aria-label={t('nav.homepage')} role="menuitem">
                                    <img
                                        className={'logo'}
                                        height={"50px"}
                                        src={highContrast? logo2 : logo}
                                        alt={t('nav.logoAlt')}
                                        style={{
                                            height: '130px',
                                            width: 'auto',
                                            marginTop: `-3rem`,
                                            marginBottom: `-3rem`,
                                        }}
                                    />
                                </a>

                            </li>
                            <li className="navigation__item" role="none">
                                <a
                                    id="conf-tab"
                                    className={`navigation__link ${configuratorTab ? 'disabled' : ''}`}
                                    onClick={handleConfiguratorTab}
                                    href={process.env.PUBLIC_URL + '/'}
                                    tabIndex="0"
                                    aria-current={configuratorTab ? "page" : undefined}
                                    aria-disabled={configuratorTab ? "true" : "false"}
                                    role="menuitem"
                                >
                                    {t('nav.configurator')}
                                </a>
                            </li>
                            <li className="navigation__item" role="none">
                                <button
                                    className={`navigation__link ${loginTab ? 'disabled' : ''}`}
                                    onClick={handleLoginTab}
                                    tabIndex="0"
                                    style={{background: "none", border: "none", cursor: "pointer"}}
                                    aria-current={loginTab ? "page" : undefined}
                                    aria-disabled={loginTab ? "true" : "false"}
                                    role="menuitem"
                                >
                                    {t('nav.myAccount')}
                                </button>
                            </li>
                            <li className="navigation__item" role="none">
                                <button
                                    className="navigation__link"
                                    onClick={increaseFontSize}
                                    aria-label={t('nav.increaseFontSize')}
                                    tabIndex="0"
                                    role="menuitem"
                                    style={{background: "none", border: "none", cursor: "pointer"}}
                                >
                                    A+
                                </button>
                            </li>
                            <li className="navigation__item" role="none">
                                <button
                                    className="navigation__link"
                                    onClick={decreaseFontSize}
                                    aria-label={t('nav.decreaseFontSize')}
                                    tabIndex="0"
                                    role="menuitem"
                                    style={{background: "none", border: "none", cursor: "pointer"}}
                                >
                                    A-
                                </button>
                            </li>
                            <li className="navigation__item" role="none">
                                <button
                                    className="navigation__link navigation__link--contrast"
                                    onClick={toggleContrast}
                                    aria-label={highContrast ? t('nav.contrastOff') : t('nav.contrastOn')}
                                    aria-checked={highContrast}
                                    tabIndex="0"
                                    role="menuitemcheckbox"
                                    style={{background: "none", border: "none", cursor: "pointer"}}
                                >
                                    {highContrast ? t('nav.contrastLabelOff') : t('nav.contrastLabelOn')}
                                </button>
                            </li>
                            <li className="navigation__item" role="none">
                                <LanguageSwitcher/>
                            </li>
                        </ul>
                        <div className="navigation__item navigation__item--eu-logo">
                            <a
                                href={DOTACJE_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={t('nav.euFlagAriaLabel')}
                                className="navigation__link navigation__link--eu-flag"
                            >
                                <img height={"50px"} src={logoEU} alt=""/>
                            </a>
                        </div>
                        </nav>
                    </div>
                    <div className="col-12">
                        {configuratorTab &&
                            <div className="heading heading--center">
                                <div className="heading__line" aria-hidden="true"></div>
                                <h1 className="heading__title" tabIndex="0">
                                    {t('configurator.title')}
                                </h1>
                                <div className="heading__description">
                                    <p>
                                        {t('configurator.description')}
                                    </p>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="col-12">
                        {loginTab ? <LoginFormWrapper/> : null}
                        {configuratorTab ? <TextSectionsList/> : null}
                        {exportTab ? <SavedConfigurationList/> : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
